$(function(){

    $('.dropdown-angle .dropdown-item').click(function(){
        //var dropdownButton = $('.dropdown-angle .btn-dropdown .btn-title');
        //Find the parent rather than a top-down approach so that the button is reusable
        let dropdownButton = $(this).parents('button').find('.btn-title');
        $(dropdownButton).text($(this).text()).val($(this).text()).addClass('value');
   });

});